import type * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

type ErrorType = Omit<React.HTMLAttributes<HTMLParagraphElement>, 'css'> & {
  error: boolean;
};

const StyledP = styled.p<ErrorType>`
  ${tw`block mt-1 body-xs text-gray-700 min-h-4`}
  ${({ error }) => error && tw`text-red-600`}
`;
export const HelperText: React.FunctionComponent<ErrorType> = ({
  error,
  ...rest
}) => <StyledP error={error} {...(error && { role: 'alert' })} {...rest} />;
